export function getAccessToken() {
  return (localStorage.getItem('accessToken') || '').replaceAll(/"/g, '');
}

export function getAuthorizationHeader() {
  return `${getAccessToken()}`;
}

export function getUserData() {
  const userData = localStorage.getItem('userData');
  if (userData) {
    return JSON.parse(userData);
  }
  return undefined;
}
